<div class="container" *ngIf="displayErrorMessage">
    <div class="row">
        <h4 class="text-danger">{{ 'ssoLogin.globalMessage.ssoLoginFailure' | cxTranslate }}</h4>
    </div>
</div>
